import { Button, ButtonGroup, Box, Icon, SubHeading, Paragraph, Heading } from '@alto-avios/alto-ui'
import Head from 'next/head'
import Image from 'next/image'
import useIntl from '~/hooks/useIntl/useIntl'
import { getAuthEndpoint } from '~/utils/auth'
import { getPublicAssetSrc } from '~/utils/assets'

const BARCMemberLayout = () => {
  const intl = useIntl()
  const t = {
    upgradeText: intl.formatMessage({
      id: 'upgrade-text',
      defaultMessage: 'Upgrade to the Executive Club <bold> for free </bold> to continue',
    }),
    upgradeText2: intl.formatMessage({
      id: 'upgrade-text2',
      defaultMessage: 'Executive Club members get access to our reward platform where you can:',
    }),
    upgradeBenefit1: intl.formatMessage({
      id: 'upgrade-benefit1',
      defaultMessage: 'Collect Avios when you spend cash',
    }),
    upgradeBenefit2: intl.formatMessage({
      id: 'upgrade-benefit2',
      defaultMessage: 'Spend your Avios on fantastic rewards',
    }),
    upgradeBenefit3: intl.formatMessage({
      id: 'upgrade-benefit3',
      defaultMessage: 'Track and manage your Avios balance',
    }),
    upgradeCta: intl.formatMessage({
      id: 'upgrade-cta',
      defaultMessage: 'Join our Executive Club now',
    }),
    redirectUrl: intl.formatMessage({
      id: 'redirect-url',
      defaultMessage: 'https://www.britishairways.com/travel/EXECENROL/public/en_gb',
    }),
    backToLogin: intl.formatMessage({
      id: 'back-to-login',
      defaultMessage: 'Back to login',
    }),
  }
  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>British Airways, upgrade to Executive Club</title>
      </Head>

      <Box
        flexDirection="column"
        height="100vh"
        width="100vw"
        justifyContent="center"
        alignItems="center"
        style={{ height: '100vh' }}
      >
        <Box flexDirection="column" justifyContent="center" maxWidth="23rem" gap="md">
          <Box
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            padding="lg"
            gap="md"
          >
            <Image
              src={getPublicAssetSrc('/assets/british-airways-executive-club.svg')}
              alt="British Airways Executive Club Logo"
              height={80}
              width={300}
            />
            <Heading size="sm" padding="md" textAlign="center">
              {t.upgradeText}
            </Heading>
          </Box>

          <SubHeading size="xs" textAlign="start">
            {t.upgradeText2}
          </SubHeading>
          <Paragraph>
            <Box gap="xs">
              <Icon isDecorative iconName="circle-check" />
              <span>{t.upgradeBenefit1}</span>
            </Box>
            <Box gap="xs">
              <Icon isDecorative iconName="circle-check" />
              <span>{t.upgradeBenefit2}</span>
            </Box>
            <Box gap="xs">
              <Icon isDecorative iconName="circle-check" />
              <span>{t.upgradeBenefit3}</span>
            </Box>
          </Paragraph>
          <ButtonGroup align="stack">
            <Button
              as="a"
              href="https://www.britishairways.com/travel/EXECENROL/public/en_gb"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.upgradeCta}
            </Button>
            <Button as="a" href={getAuthEndpoint('LOGOUT')} emphasis="quaternary">
              {t.backToLogin}
            </Button>
          </ButtonGroup>
        </Box>
      </Box>
    </>
  )
}

export default BARCMemberLayout
